import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/icon-excel.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-43fab731")

_pushScopeId("data-v-43fab731")
const _hoisted_1 = { class: "py-2 bg-gray background-gray mt-2 rounded-lg w-fit" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 divide-x divide-x-gray-lp-300 " }
const _hoisted_3 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "icon excel"
}, null, -1)
const _hoisted_5 = { class: "font-medium text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "font-medium text-16px",
      "data-testid": `bulk-booking-create-title-${_ctx.typeDownload}`
    }, _toDisplayString(_ctx.title), 9, ["data-testid"]),
    _createVNode("div", {
      class: "text-14px text-gray-lp-500 mt-1",
      "data-testid": `bulk-booking-create-hint-${_ctx.typeDownload}`
    }, _toDisplayString(_ctx.description), 9, ["data-testid"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataComponent, (item, idx) => {
          return (_openBlock(), _createBlock(_Fragment, { key: idx }, [
            (item.permission)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  "data-testid": item.dataTestId,
                  class: "flex flex-row gap-2 justify-between items-center px-4 background-gray w-full"
                }, [
                  _createVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("div", _hoisted_5, _toDisplayString(item.title), 1)
                  ]),
                  (item.isButton)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "download-new",
                        class: "w-2 text-red-lp-2400 cursor-pointer",
                        onClick: () => _ctx.onDownloadDocument(item.url, item.title),
                        id: item.id
                      }, null, 8, ["onClick", "id"]))
                    : (_openBlock(), _createBlock(_component_Icons, {
                        key: 1,
                        name: "chevron-right-thin",
                        class: "w-2 text-black cursor-pointer",
                        onClick: () => _ctx.onDownloadCsv(item.title, item.type),
                        id: item.id
                      }, null, 8, ["onClick", "id"]))
                ], 8, ["data-testid"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ]))
})